/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Case_Payment_Installment_RowInputs */

const en_case_payment_installment_row = /** @type {(inputs: Case_Payment_Installment_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Installment ${i?.number}`)
};

const pt_br2_case_payment_installment_row = /** @type {(inputs: Case_Payment_Installment_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parcela ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Installment {number}" |
*
* @param {Case_Payment_Installment_RowInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_installment_row = /** @type {((inputs: Case_Payment_Installment_RowInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Installment_RowInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_installment_row(inputs)
	return pt_br2_case_payment_installment_row(inputs)
});